import template from './activationStatus.html';
import '../activationStatus.scss';

/**
 * @typedef  {Object} ActivationStatus
 * @property {String} tooltip           Message shown within the Tooltip.
 * @property {String} image             Icon URL to show in the status section.
 * @property {String} status            The status name.
 */

/**
 * @ngdoc controller
 * @name OdsActivationStatus
 * @description
 * This component renders a media's activation list.
 */
class OdsActivationStatus {
  constructor() {
    /**
     * The number of activation icons visible on the component.
     * @type {Number}
     */
    this.visibleActivationAmount = 2;
    /**
     * The list of visible activation icons on the component.
     * @type {Array}
     */
    this.visibleActivations = [];
    /**
     * The number of not visible activation icons on the component.
     * @type {Number}
     */
    this.notVisibleActivationsCount = 0;
  }
  /**
   * Each time the activations binding changes, update the list of visible activation icons and
   * the number of not visible activation icons.
   *
   * @param {Object} changes              The binding changes.
   * @param {Object} changes.activations  The activations change object.
   */
  $onChanges({ activations }) {
    if (activations && activations.currentValue && this.activations) {
      this.visibleActivations = this.activations.slice(0, this.visibleActivationAmount);
      this.notVisibleActivationsCount = this.activations.length - this.visibleActivationAmount;
    }
  }
}

/**
 * @ngdoc component
 * @name OdsActivationStatus
 * @description
 * The activation status gadget.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsActivationStatusController}
   */
  controller: OdsActivationStatus,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings.
   * @type {Object}
   * @property {Array<ActivationStatus>} activations  The list of activations to display.
   */
  bindings: {
    activations: '<',
  },
};
